<template>
  <login :login-party="'merchantLogin'"></login>
</template>

<script>
import login from "@/components/login/Login";
export default {
  components: { login },
};
</script>
